import React from 'react';
import HookFormInput from 'src/hook-form-wrapper/form-input';
import {View} from 'react-native';
import {useForm, FormProvider} from 'react-hook-form';
import {RHButton} from 'src/common-components/custom-ui-helpers';
import {useStyle} from 'src/providers/style';
import {useTranslations} from 'src/providers/translation';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import HookFormSwitchInput from 'src/hook-form-wrapper/switch-input';

interface Props {
  onAssign: any;
  eventCategory: any;
}

const EventCategoryForm = ({onAssign, eventCategory}: Props) => {
  const styles = useStyle();
  const translations = useTranslations();
  const validationSchema = Yup.object({
    name: Yup.string().required(),
  });
  const initialValues = {
    name: eventCategory?.name || '',
    billable: eventCategory?.billable || false,
  };

  const methods = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  console.log();
  return (
    <FormProvider {...methods}>
      <HookFormInput name={'name'} label={'Event Name (e.g. Meeting Time)'} />
      <HookFormSwitchInput
        label={'Display on Timesheet'}
        name={'billable'}
        showHelper={false}
      />
      <View style={[styles.row, styles.alignCenter, styles.justifyEnd]}>
        <RHButton
          secondary
          mode="contained"
          onPress={methods.handleSubmit(onAssign)}>
          {translations('save_button')}
        </RHButton>
      </View>
    </FormProvider>
  );
};

export default EventCategoryForm;
